module.exports = __webpack_public_path__ + "img/Airbnb-Equipmnet-Lighting.059023ca.jpg";